import { Landing } from "components";
import AboutView from "./AboutView";

export const AboutContainer = () => {
  return (
    <Landing>
      <AboutView />
    </Landing>
  );
};
